<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Creator</th>
        <th scope="col">Title</th>
        <th scope="col">Creation date</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="task in tasks" :key="task.id">
        <th scope="row">{{ task.id }}</th>
        <td>{{ getOriginalCreator(task) }}</td>
        <td class="align-left">{{ removeHtml(task.content) }}</td>
        <td class="align-left">{{ task.created_at }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import apiClientCreator from "@/helpers/api/request";
import TaskModel from "@/features/tasks.feature/components/TaskModel";

export default {
  name: "TasksShortTable",
  data() {
    return {
      tasks: []
    };
  },
  mounted() {
    this.fetchTasks();
  },
  methods: {
    fetchTasks(withStats) {

      let apiClient = apiClientCreator("tasks/list");
      this.$store.commit("clients/setLoading", true);
      // const queryParams = this.getQueryParams();
      const tasks = [];
      // this.tasks = [];
      apiClient
        // .get("", { params: queryParams })
        .get("")
        .then(res => {
          res.data.data.forEach(function(data) {
            tasks.push(new TaskModel(data));
          });
          // this.getQueryParamsToMs = queryParams;

          // if (!withStats) {
          //   this.updateStats();
          // }
          // this.tasks = [];

          this.tasks = tasks;
          // this.pagination.currentPage = res.data.current_page;
          // this.pagination.perPage = res.data.per_page;
          // this.pagination.from = res.data.from;
          // this.pagination.to = res.data.to;
          // this.pagination.lastPage = res.data.last_page;
          // this.pagination.total = res.data.total;
          // this.resetCalendars = false;
          // this.resetMultiSelects = false;
          // this.sendUpdated = true;
          this.$store.commit("clients/setLoading", false);
          // this.setAllTasksTotalTimeFormat();

          return res;
        })
        .catch(e => {
          this.$store.commit("main/setShowVikiMsg", {
            show: true,
            msg:
              "Connection Error!" + " " + " Error Status: " + e.response.status,
            type: "ERROR",
            op: { type: "SYSTEM" }
          });

          this.$store.commit("clients/setLoading", false);
        });
    },
    getOriginalCreator(task) {
      let originalCreator = null;
      task.task_assignment.forEach(assign => {
        if (assign.assigned_to.id === assign.assigned_by.id) {
          originalCreator = assign.assigned_by.first_name;
        }
      });
      return originalCreator;
    },
    removeHtml(content) {
      return content.replace(/<\/?[^>]+(>|$)/g, " ");
    }
  }
};
</script>

<style scoped>
th {
  text-align: center;
}
.align-left {
  text-align: left;
}
</style>
